import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'reactstrap'

import { GeneralEmployerCard } from 'features/employer/components/Employers/Cards'

export const Grid = ({ items, ...props }) => {
  const { t } = useTranslation()

  return (
    <>
      {items.map((item, i) => (
        <Row key={i}>
          <Col>
            <GeneralEmployerCard data={item} {...props} />
          </Col>
        </Row>
      ))}
    </>
  )
}

Grid.propTypes = {
  items: PropTypes.array,
}
